<template>
  <div class="col-xs-12">
    <div class="col-xs-12">
      <div class="form-center box-body">
        <div class="input-group">
          <span class="input-group-addon">
            優惠券折抵規則
          </span>
          <span class="form-control form-info">{{newCouponType.label}}</span>
        </div>
        <br />
        <div>
          <div class="input-group">
            <span class="input-group-addon">折抵策略名稱</span>
            <span class="form-control form-info">{{giveCoupons.coupon_strategy.name}}</span>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">折抵描述</span>
            <span class="form-control form-info">{{giveCoupons.coupon_strategy.description}}</span>
          </div>
          <br />
        </div>
        <br>
      </div>
    </div>
    <div class="col-xs-12" v-if="newCouponType">
      <hr class="box-body">
      <div class="box-body form-center">
        <div>
          <h4>使用規則</h4>
        </div>
      </div>
      <div class="form-left box-body">
        <div class="m-t-10" v-if="ruleCode === 'SC00003'">
          <div class="input-group">
            <span class="input-group-addon">滿足商品金額 (買X元，送優惠券)</span>
            <span class="form-control form-info">{{giveCoupons.coupon_strategy.setting.money_unit}}</span>
          </div>
          <br />
        </div>
        <div v-if="ruleCode === 'SC00001'">
          <div class="input-group">
            <span class="input-group-addon">商品限制最低單價</span>
            <span class="form-control form-info" v-if="giveCoupons.coupon_strategy.setting.lowest_unit_price">{{giveCoupons.coupon_strategy.setting.lowest_unit_price}} 元</span>
            <span class="form-control form-info" v-else>無設定</span>
          </div>
          <br />
        </div>
        <div>
          <div class="input-group">
            <span class="input-group-addon">一次最大使用張數</span>
            <span class="form-control form-info" v-if="giveCoupons.coupon_strategy.setting.one_max_amount">{{giveCoupons.coupon_strategy.setting.one_max_amount}} 張</span>
            <span class="form-control form-info" v-else>無設定</span>
          </div>
          <br />
        </div>
      </div>
    </div>
    <div class="col-xs-12" v-if="newCouponType">
      <hr class="box-body">
      <div class="box-body form-center">
        <div>
          <h4>限制規則</h4>
        </div>
      </div>
      <div class="form-left box-body">
        <div>
          <div class="input-group">
            <span class="input-group-addon">限制主單(或團長)最低購買數</span>
            <span class="form-control form-info">{{giveCoupons.coupon_strategy.limit.min_amount}} 個</span>
          </div>
          <br />
        </div>
        <div v-if="giveCoupons.coupon_strategy.limit.order_types.length">
          <div class="input-group">
            <span class="input-group-addon">
              訂單類型
            </span>
            <div class="form-control form-info">
              <label class="label-success label m-r-5" v-for="ot in giveCoupons.coupon_strategy.limit.order_types">{{ot.label}}</label>
            </div>
          </div>
          <br>
        </div>
        <div v-if="giveCoupons.coupon_strategy.limit.order_method.length">
          <div class="input-group">
            <span class="input-group-addon">
              訂單方案
            </span>
            <div class="form-control form-info">
              <label class="label-success label m-r-5" v-for="om in giveCoupons.coupon_strategy.limit.order_method">{{om.label}}</label>
            </div>
          </div>
          <br>
        </div>
      </div>
      <div class="form-right box-body">
        <div v-if="giveCoupons.coupon_strategy.limit.delivery_types.length">
          <div class="input-group">
            <span class="input-group-addon">
              取貨方式
            </span>
            <div class="form-control form-info">
              <label class="label-success label m-r-5" v-for="dt in giveCoupons.coupon_strategy.limit.delivery_types">{{dt.label}}</label>
            </div>
          </div>
          <br>
        </div>
        <div v-if="giveCoupons.coupon_strategy.limit.min_money">
          <div class="input-group">
            <span class="input-group-addon">限制主單(或團長)最低總金額</span>
            <span class="form-control form-info">{{giveCoupons.coupon_strategy.limit.min_money}} 元</span>
          </div>
          <br />
        </div>
      </div>
    </div>
    <div class="col-xs-12">
      <hr class="box-body">
      <div class="box-body form-center" v-if="giveCoupons.coupon_strategy.store_exception_items[0].products.length || giveCoupons.coupon_strategy.setting.vendor_custom_product_list.length">
        <div style="margin-bottom: 20px">
          <h5 v-if="ruleCode === 'SC00001' || ruleCode === 'SC00003'">例外商品選擇</h5>
          <h5 v-else>指定商品選擇</h5>
        </div>
        <div class="m-t-10" v-if="giveCoupons.coupon_strategy.store_exception_items[0].products.length && (ruleCode === 'SC00001' || ruleCode === 'SC00003')">
          <table class="table table-bordered table-striped dataTable">
            <thead class="bg-primary">
            <tr>
              <td>＃</td>
              <td>商品</td>
              <td>商品料號</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(aProduct, aIndex) in giveCoupons.coupon_strategy.store_exception_items[0].products">
              <td>
                {{aIndex + 1}}
              </td>
              <td>
                {{aProduct.product_name}}
              </td>
              <td>
                <div>{{aProduct.vendor_custom_id}}</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="m-t-10" v-if="giveCoupons.coupon_strategy.setting.vendor_custom_product_list.length && ruleCode === 'SC00002'">
          <table class="table table-bordered table-striped dataTable">
            <thead class="bg-primary">
            <tr>
              <td>＃</td>
              <td>商品</td>
              <td>商品料號</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(aProduct, aIndex) in giveCoupons.coupon_strategy.setting.vendor_custom_product_list">
              <td>
                {{aIndex + 1}}
              </td>
              <td>
                {{aProduct.product_name}}
              </td>
              <td>
                <div>{{aProduct.vendor_custom_id}}</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import menuDiscount from '../../Discount/Temp/MenuDiscountTemp.vue'
export default {
  components: {
    'menu-discount': menuDiscount
  },
  props: {
    giveCoupons: Object,
    info: Object,
    brandList: Array,
    storeList: Array,
    aStoreOption: Array,
    setInfoTimes: Number
  },
  data () {
    return {
      addStoresSetting: {
        class: 'coupon-store',
        options: [],
        choose: []
      },
      ruleCode: '',
      newCouponType: {label: '消費商品數量滿額', value: 'SC00001'},
      ruleCodeOptions: [
        {label: '消費商品數量滿額', value: 'SC00001'},
        {label: '消費指定商品滿額', value: 'SC00002'},
        {label: '消費金額滿額', value: 'SC00003'}
      ],
      orderType: [
        {label: '一般單', value: 1},
        {label: '團購單 - 團長', value: 2},
        {label: '團購單 - 團員', value: 3}
      ],
      orderMethod: [
        {label: '當日單', value: 1},
        {label: '預訂單', value: 2}
      ],
      deliveryType: [
        {label: '自取', value: 1},
        {label: '內用', value: 2},
        {label: '外送', value: 3},
        {label: '內用-桌邊掃碼', value: 21}
      ],
      dStrategy: {
        rule_code: '',
        name: '',
        description: '',
        limit: {
          delivery_types: [],
          order_types: [],
          order_method: '',
          min_money: '',
          min_amount: ''
        },
        setting: {
          // SC0001
          one_max_amount: '', //
          ratio: 1,
          lowest_unit_price: 0,
          // SC00002
          vendor_custom_product_list: [],
          // SC00003
          money_unit: ''
        },
        // SC00001、SC00002、SC00003
        store_exception_items: [
          {
            products: [],
            store_ids: []
          }
        ]
      },
      storeSelect: {label: '', value: '', brand_id: ''},
      menuSelect: {
        label: '',
        value: 0
      },
      tableIndex: 1,
      count: 20,
      menuList: []
    }
  },
  methods: {
    getOnlineMenu () {
      var self = this
      self.menuList = []
      let select = this.storeSelect
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + select.brand_id + '&store_id=' + select.value
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var mList = response.data.menu_list
          mList.forEach(function (menu, index) {
            var option = {label: menu.name, value: menu.id}
            self.menuList.push(option)
            if (index === 0) self.menuSelect = option
          })
          if (!mList.length) self.menuSelect = {label: '', value: ''}
          // self.total = response.data.total
        }
      })
    },
    clickOption (option) {
      var self = this
      this.addStoresSetting.options = []
      self.curId = option.id
      if (self.curId) {
        self.$nextTick(function () {
          self.reSet++
          self.addStoresSetting.options = self.storeBrief
          self.getCurStoreClass()
        })
      }
    },
    getCurStoreClass () {
      this.addStoresSetting.choose = []
      var self = this
      var url = '/brand/' + this.brandSelect.value + '/storeClass/' + this.curId
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var classInfo = response.data.class
          classInfo.store_list.forEach(function (s) {
            self.addStoresSetting.choose.push(s.id)
            // console.log(self.addStoresSetting.choose)
            // console.log(s)
          })
        }
      })
    },
    setStore () {
      var self = this
      let stores = this.info.attend_stores
      // console.log(stores)
      if (stores.length) {
        stores[0].store_list.forEach(function (store) {
          self.addStoresSetting.choose.push(store.store_id)
        })
      }
    },
    addProdToList (addPInfo) {
      // console.log(addPInfo)
      var self = this
      var pInfo = this.giveCoupons.coupon_strategy.setting.vendor_custom_product_list
      // console.log(pInfo)
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id
        })
        if (!isSame) pInfo.push(addP)
        else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          })
        }
      })
    },
    addExProdToList (addPInfo) {
      // console.log(addPInfo)
      var self = this
      var pInfo = this.giveCoupons.coupon_strategy.store_exception_items[0].products
      // console.log(this.giveCoupons.coupon_strategy)
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id
        })
        if (!isSame) {
          pInfo.push(addP)
        } else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          })
        }
      })
    },
    addExProdToList3  (addPInfo) {
      // console.log(addPInfo)
      // console.log(pInfo)
      var self = this
      var pInfo = this.giveCoupons.coupon_strategy.store_exception_items[0].products
      addPInfo.forEach(function (addP) {
        var isSame = pInfo.find(function (prod) {
          return addP.vendor_custom_id === prod.vendor_custom_id
        })
        if (!isSame) pInfo.push(addP)
        else {
          self.$notify({
            title: '提醒',
            text: addP.product_name + '已加入過',
            duration: 3000,
            width: 400
          })
        }
      })
    },
    removeListItem (list, index) {
      list.splice(index, 1)
    },
    returnNum (e) {
      var charCode = (e.which) ? e.which : e.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        e.preventDefault()
      } else {
        return true
      }
    },
    setInfo () {
      const self = this
      // info
      let iStrategy = this.info.give_coupons[0].coupon_strategy
      const iLimit = iStrategy.limit
      const iSetting = iStrategy.setting
      this.ruleCode = iStrategy.rule_code
      // coupon
      let cStrategy = {
        rule_code: iStrategy.rule_code,
        name: iStrategy.strategy_name,
        description: iStrategy.strategy_description,
        limit: {
          delivery_types: [],
          order_types: [],
          order_method: '',
          min_money: iLimit.min_money,
          min_amount: iLimit.min_amount
        },
        setting: {
          // SC0001
          one_max_amount: '',
          ratio: 1,
          lowest_unit_price: 0,
          // SC00002
          vendor_custom_product_list: [],
          // SC00003
          money_unit: ''
        },
        // SC00001、SC00002、SC00003
        store_exception_items: [
          {
            products: [],
            store_ids: []
          }
        ]
      }
      const cLimit = cStrategy.limit
      const cSetting = cStrategy.setting
      this.newCouponType = this.ruleCodeOptions.find(function (rc) { return rc.value === iStrategy.rule_code })
      // order_type
      if (iLimit.order_type) {
        iLimit.order_type.forEach(function (orderType) {
          const otop = self.orderType.find(function (ot) { return ot.value === orderType })
          cLimit.order_types.push(otop)
        })
      }
      // order_method
      if (iLimit.order_method) {
        const omop = self.orderMethod.find(function (om) { return om.value === iLimit.order_method })
        cLimit.order_method = omop
      }
      // delivery_type
      if (iLimit.delivery_type) {
        iLimit.delivery_type.forEach(function (deliveryType) {
          const dtop = self.deliveryType.find(function (dt) { return dt.value === deliveryType })
          cLimit.delivery_types.push(dtop)
        })
      }
      if (iSetting.one_max_amount) cSetting.one_max_amount = iSetting.one_max_amount
      if (iSetting.lowest_unit_price) cSetting.lowest_unit_price = iSetting.lowest_unit_price
      if (iSetting.vendor_custom_product_list) {
        iSetting.vendor_custom_product_list.forEach(function (item) {
          const obj = {vendor_custom_id: item.id, product_name: item.name}
          cSetting.vendor_custom_product_list.push(obj)
        })
      }
      if (iSetting.money_unit) cSetting.money_unit = iSetting.money_unit
      if (iStrategy.store_exception_items.length) {
        iStrategy.store_exception_items[0].products.forEach(function (item) {
          const obj = {vendor_custom_id: item.vendor_custom_id, product_name: item.name}
          cStrategy.store_exception_items[0].products.push(obj)
        })
        iStrategy.store_exception_items[0].stores[0].store_list.forEach(function (store) {
          cStrategy.store_exception_items[0].store_ids.push(store.store_id)
        })
      }
      // console.log(3, cSetting)
      this.giveCoupons.coupon_strategy = cStrategy
      // console.log(this.giveCoupons.coupon_strategy)
    },
    reNewMenu (select) {
      // console.log('reNewMenu')
      this.ruleCode = this.giveCoupons.coupon_strategy.rule_code = select.value
      this.giveCoupons.coupon_strategy.store_exception_items[0].products = []
      this.giveCoupons.coupon_strategy.setting.vendor_custom_product_list = []
      this.storeSelect = {label: '', value: '', brand_id: ''}
      this.menuSelect = {label: '', value: 0}
    }
  },
  created () {
    this.giveCoupons.coupon_strategy = this.dStrategy
    this.ruleCode = this.giveCoupons.coupon_strategy.rule_code = this.newCouponType.value
    // console.log(this.ruleCode)
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  },
  watch: {
    'storeSelect.value' () {
      // console.log(this.storeSelect)
      if (this.storeSelect.value) {
        this.getOnlineMenu()
      }
    },
    setInfoTimes () {
      this.setInfo()
    }
  }
}
</script>
<style lang="sass" scoped>
  .un-active
    opacity: .3
</style>



// WEBPACK FOOTER //
// CouponStrategyInfo.vue?6bf8126f